<script>
    import { onMount } from "svelte";
    import { apiMethods } from "../../Services/index.svelte";
    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";
    import ExceptionInfo from "./components/ExceptionInfo.svelte";
    import ExceptionContent from "./components/ExceptionContent.svelte";
    import ExceptionData from "./components/ExceptionData.svelte";
    import { showError } from "../../Utils/utilFunctions.svelte";

    export let params = {};

    let isLoadingException = false,
        exceptionData = {};

    onMount(() => {
        if (params.id) loadExceptionById(params.id);
    });

    const loadExceptionById = async (id) => {
        isLoadingException = true;

        await apiMethods.getMethod.getExceptionLogById(id).then(async (res) => {
            if (res.id) exceptionData = { ...res };
            else showError(res.error);
        });

        isLoadingException = false;
    };
</script>

{#if isLoadingException}
    <PageLoading />
{:else}
    <PageHead title="View Exception Log" />

    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <ExceptionInfo {exceptionData} />

            <ExceptionContent content={exceptionData.content} />

            <ExceptionData data={exceptionData.exceptionData} />
        </div>
    </div>
{/if}
